import BarIndicator from './BarIndicator';

export default BarIndicator;
